import { useGetRegister } from '@/modules/issuer-dashboard/hooks/useGetRegister.tsx';
import { InfoCard } from 'ui';
import { CopyIcon } from 'ui/icons';
import { copyTextToClipBoard } from 'ui/utils';

export const AiTrackerEmailBlock = () => {
  const register = useGetRegister();
  return (
    <InfoCard title="Copy Email Address" classes={{ content: 'space-y-3 pt-3' }}>
      <p
        className="flex gap-1 items-center cursor-pointer text-sm min-w-[220px]"
        onClick={copyTextToClipBoard.bind(null, register?.custodial_updates_email ?? '', {
          successMessage: 'Email copied successfully',
        })}
      >
        <span className="truncate">{register?.custodial_updates_email ?? ''}</span>
        <img src={CopyIcon} alt="copy" width={18} />
      </p>
      <p className="text-sm">
        Give this email to your broker to automatically track correspondence and convert it into
        transactions in Compli One Self Custody using AI. Or if you're sending an email letter (e.g.
        booking a trade), just add this address to CC.
      </p>
    </InfoCard>
  );
};
